<template>
    <div>       
        <post-search :user_id='user.id'/>    
    </div>
</template>
<script>
import { auth } from '@/components/mixins/auth.js'
import PostSearch from '@/pages/posts/PostSearch.vue'
export default {  
    mixins:[auth], 
    components:{
        PostSearch
    }    
}
</script>
<style lang="scss" scoped>

</style>
